import { render, staticRenderFns } from "./viewInvoiceTreatment.vue?vue&type=template&id=7cb5ed6b&"
import script from "./viewInvoiceTreatment.vue?vue&type=script&lang=js&"
export * from "./viewInvoiceTreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports